import { render, staticRenderFns } from "./setting-usersRoles.vue?vue&type=template&id=172ef0f7&scoped=true&"
import script from "./setting-usersRoles.vue?vue&type=script&lang=js&"
export * from "./setting-usersRoles.vue?vue&type=script&lang=js&"
import style0 from "./setting-usersRoles.vue?vue&type=style&index=0&id=172ef0f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172ef0f7",
  null
  
)

export default component.exports